import {React, useState, useContext, useEffect} from 'react';
import {Buffer} from 'buffer';
import { useNavigate  } from 'react-router-dom';
import UserContext from '../context/UserContext';
import DesktopViewContext from '../context/DesktopViewContext';
import menu from "../logos/menu.svg";
import user_cv from "../logos/user_cv.svg";
import add_job from "../logos/add_job.svg";
import admin from "../logos/admin.svg";
import logout from "../logos/logout.svg";
import logo from "../logos/logo.svg";
import driver from "../logos/driver.svg";
import {  GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import Welcome from './Welcome';

function Header() {
  const [tiktak, setTiktak] = useState(true);
  useEffect(() => {
    let intervalId;
    const toggleState = () => {
      setTiktak(!tiktak);
    };

    intervalId = setInterval(toggleState, 5000);
    return () => clearInterval(intervalId);
  }, [tiktak]);
  const { desktopView, setDesktopView } = useContext(DesktopViewContext);
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showWelcome, setShowWelcome] = useState(false);
  const [showCookie, setShowCookie] = useState(false);
  const [cookieAccepted, setCookieAccepted] = useState(true);
  const [cookieAnswered, setCookieAnswered] = useState(false);
  const { user, setUser } = useContext(UserContext);
  const navigateToHome = () => {
    closeMenu();
    navigate("/"); 
  };
  const navigateToCreateJob = () => {
    closeMenu();
    navigate("/createjob"); 
  };
  const navigateToCv = () => {
    closeMenu();
    navigate("/cv"); 
  };
  const navigateToUsers = () => {
    closeMenu();
    navigate("/users"); 
  };
  const navigateToAdmin = () => {
    closeMenu();
    navigate("/admin"); 
  };
  const navigateToWhy = () => {
    closeMenu();
    navigate("/tellmewhy"); 
  };
  const navigateToDataPrivacy = () => {
    closeMenu();
    navigate("/data-privacy"); 
  };
  const [userPicture, setUserPicture] = useState(null);
  const api_endpoint = process.env.REACT_APP_API_ENDPOINT;
  const onSuccess = async (res) => {
    const decodedUser = jwtDecode(res.credential);
    setUser(decodedUser);
    
    setIsMenuOpen(false);
    setUserPicture(decodedUser.picture);
    if (!cookieAccepted)  return;
      
    localStorage.setItem("user", JSON.stringify(decodedUser));
    localStorage.setItem("exp", JSON.stringify(Date.now() + (24 * 60 * 60 * 1000)));


    try {
      const response = await fetch(api_endpoint + "/api/users", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "google-id": decodedUser.sub,
          name: Buffer.from(decodedUser.name).toString('base64'),
          email: Buffer.from(decodedUser.email).toString('base64'),
        },
      });

      const data = await response.json();
      console.log("Server response:", data);

      if (data.user) {
        localStorage.setItem("user", JSON.stringify(data.user));
        localStorage.setItem("picture", JSON.stringify(decodedUser.picture));
        setUser(data.user);
      }
    } catch (error) {
      console.error("Error inserting user:", error);
    }

  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("picture");
    localStorage.removeItem("exp");
    setUser(null);
    setUserPicture(null);
    closeMenu();
    navigateToHome();
  };

  useEffect(() => {
    const exp = localStorage.getItem("exp");
    if (!exp) setShowWelcome(true);


      if (
        exp &&
        (exp - Math.floor(Date.now())) < 20
      ) {
        handleLogout();
        return;
      }

      const storedUser = localStorage.getItem("user");
      if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUser(parsedUser);

      const storedPicture = localStorage.getItem("picture");
      if (storedPicture) {
        const decodedPicture = JSON.parse(storedPicture);
        setUserPicture(decodedPicture);
      }
    }

    setTimeout(() => {
      setShowWelcome(false);
    }, 5000);
  }, []);

  useEffect(() => {
    setDesktopView(window.innerWidth > 1500);
  }, [window.innerWidth]);

  const cookieConsent = () => {
    const alreadyBeenHere = localStorage.getItem("cookie");
    if (cookieAnswered ||alreadyBeenHere) return;
    setCookieAnswered(true);
      setShowCookie(true);
      setCookieAccepted(false);
  };
  const handleAcceptCookies = () => {
    localStorage.setItem("cookie", 1);
    setCookieAccepted(true);
    setShowCookie(false);
  };
  const handleDeclineCookies = () => {
    localStorage.setItem("cookie", 1);
    setCookieAccepted(false);
    setShowCookie(false);
  };
  if (showWelcome) {
    return(<Welcome/>)
  }
  return (
    <header className="App-header">
    <div onClick={navigateToHome} className="logo-container">
      <img src={logo} className="App-logo" alt="logo" />
    </div>
    {showCookie &&

<div id="simple-cookie-consent">
<div class="cookie-consent-container">
  <div class="cookie-consent-notice">
    <h4>Sütik</h4>
    <p>Ez a weboldal sütiket használ, hogy a belépés gördülékenyebb legyen az oldalra. Bővebben a <a href="/data-privacy">adatvédelmi tájékoztatóban</a> olvashat róla.</p>
  </div>
  <br></br>
  <button style={{marginBottom:'10px'}} onClick={handleDeclineCookies} className="back-button">NEM ENGEDÉLYEZEM</button>
  <br></br>
  <button onClick={handleAcceptCookies} className="custom-button-invert">ENGEDÉLYEZEM</button>
</div>
</div>

    }
    {isMenuOpen && (
                <div className={ !desktopView ? "menu-overlay" : "menu-overlay desktopoverlay desktopoverlay2"}>
                  {user && user.type == "admin" && (
                    <button
                      className="custom-button"
                      onClick={navigateToAdmin}
                    >
                      Admin oldal megnyitása
                    </button>
                  )}
                  {user && (user.db_access == 1) && (
                    <button
                      className="custom-button"
                      onClick={navigateToUsers}
                    >
                      Kamionos adatbázis
                    </button>
                  )}
                  {user && (user.type == null || user.type == "admin") && (
                    <button
                      className="custom-button"
                      onClick={navigateToCv}
                    >
                      Önéletrajz szerkesztése
                    </button>
                  )}

            {!user && (
                    <>
                  <button
                    className="custom-button"
                    onClick={navigateToWhy}
                  >
                    Miért érdemes bejelentkezni?
                  </button>
                  <div 
                      onMouseEnter={cookieConsent}>
                  <GoogleLogin
                      onSuccess={onSuccess}
                      onError={(error) => console.log("Error:", error)}
                      theme="filled_blue"
                      shape="pill"
                      size="large"
                      logo_alignment="center"
                      width="40%"
                    />
                  </div>

                    </>
                  )}
                  <br></br> 
                  {user && (
                    <button className="custom-button" onClick={handleLogout}>
                      Kijelentkezés
                    </button>
                  )}
                  <button
                    className="custom-button"
                    onClick={closeMenu}
                  >
                    Bezárás
                  </button>
                  <footer className={ !desktopView ? "footer" : "footer-data-desktop"}>
        <p style={{color:'white'}} onClick={navigateToDataPrivacy}>Adatvédelmi szabályzat</p>
                    </footer>
                </div>
              )}
    {!desktopView && (
                  <>

                    <button
                          className="menu-button"
                          onClick={navigateToCreateJob}
                          style={{marginRight: '10%'}}
                        >
                          <img
                            src={add_job}
                            className="Other-logo"
                            alt="menu"
                          />
                          <span className="button-text">
                            Álláshirdetés feladása
                          </span>
                        </button>
                        {!user &&
                    <button
                      className="menu-button"
                      onClick={() => setIsMenuOpen(true)}
                      style={{marginLeft: 36, marginRight: 20}}
                    >
                      <img src={menu} className="Other-logo" alt="menu" />
                    <span style={{maxWidth: 60}} className="button-text">Menü</span>
                    </button>}
                  </>
                )}

                {desktopView && (
                  <>
                    {user && user.type == "admin" && (
                      <button
                        className="menu-button"
                        onClick={navigateToAdmin}
                      >
                        <img src={admin} className="Other-logo" alt="menu" />
                        <span className="button-text">
                          Admin oldal megnyitása
                        </span>
                      </button>
                    )}
                        <button
                          className="menu-button"
                          onClick={navigateToCreateJob}
                        >
                          <img
                            src={add_job}
                            className="Other-logo"
                            alt="menu"
                          />
                          <span className="button-text">
                            Álláshirdetés feladása
                          </span>
                        </button>
                    {user && (user.type == null || user.type == "admin") && (
                      <button
                        className="menu-button"
          
                      onClick={navigateToCv}
                      >
                        <img src={user_cv} className="Other-logo" alt="menu" />
                        <span className="button-text">
                          {" "}
                          Önéletrajz szerkesztése
                        </span>
                      </button>
                    )}
                  {user && (user.db_access == 1) && (
                      <button
                        className="menu-button"
                      onClick={navigateToUsers}
                      >
                        <img src={driver} className="Other-logo" alt="menu" />
                        <span className="button-text">
                          {" "}
                          Kamionos adatbázis
                        </span>
                      </button>
                    )}
                    {user && (
                      <button className="menu-button"
                       onClick={handleLogout}
                       >
                        <img src={logout} className="Other-logo" alt="menu" />
                        <span className="button-text"> Kijelentkezés</span>
                      </button>
                    )}
                  </>
                )}

{user && (
      <button
        className="menu-button"
        onClick={() => setIsMenuOpen(true)}
      >
        {tiktak ? (
          <img src={userPicture} className="Other-logo" alt="user picture" style={{ borderRadius: '50%' }} />
        ) : (
          <img src={menu} className="Other-logo" alt="menu icon" style={{ borderRadius: '50%' }} />
        )}
        <span className="button-text">Menü</span>
      </button>
    )}
    {!user && desktopView ? (
                    <button
                    className="menu-button"
                    onClick={() => setIsMenuOpen(true)}
                  >
                    <img src={menu} className="Other-logo" alt="menu" />
                  <span className="button-text">Regisztráció/Belépés</span>
                  </button>
    ) : null}
  </header>
  );
}

export default Header;
